import React from 'react';
import cloneDeep from 'lodash/cloneDeep';

import EditableTextView from '../../../../../../components/EditableTextView';

const editorOptions = {
  paste: {
    forcePlainText: true,
    cleanPastedHTML: false
  },
  toolbar: {
    buttons: [
      'bold',
      'italic',
      'superscript',
      'subscript',
      { name: 'justifyLeft', contentDefault: '<i class="icon-paragraph-left"></i>' },
      { name: 'justifyCenter', contentDefault: '<i class="icon-paragraph-center"></i>' },
      { name: 'justifyRight', contentDefault: '<i class="icon-paragraph-right"></i>' },
      { name: 'anchor', contentDefault: '<i class="icon-link"></i>' },
      'unorderedlist',
      'orderedlist'
    ]
  }
};

const onParagraphChange = (itemId, dispatch) => (html) => {
  dispatch('UPDATE_ITEM_DATA', {
    _id: itemId,
    paragraph: html
  });
};

const onNameChange = (itemId, dispatch) => (html) => {
  dispatch('UPDATE_ITEM_DATA', {
    _id: itemId,
    name: html
  });
};

function renderParagraph(lesson, editable, dispatch) {
  const variant = lesson.variant;
  const firstItem = lesson.items[0];
  switch (variant) {
    case 'a':
    case 'b':
    case 'c':
    case 'quoteD':
    case 'fullBackground':
      return (
        <EditableTextView
          text={firstItem.paragraph}
          placeholder="Enter some quote text here..."
          wrapperClassName="brand--body brand--linkColor"
          editable={editable}
          itemId={firstItem._id}
          onChange={onParagraphChange(firstItem._id, dispatch)}
          editorOptions={editorOptions}
        />
      );
    default:
      return null;
  }
}

function renderName(lesson, editable, dispatch) {
  const variant = lesson.variant;
  const firstItem = lesson.items[0];
  const clonedEditorOptions = cloneDeep(editorOptions);
  const extraOptions = {
    disableReturn: true
  };
  switch (variant) {
    case 'a':
    case 'b':
    case 'c':
    case 'quoteD':
    case 'fullBackground':
      return (
        <EditableTextView
          text={firstItem.name}
          placeholder="Enter name here..."
          wrapperClassName="brand--body brand--linkColor"
          editable={editable}
          itemId={firstItem._id}
          onChange={onNameChange(firstItem._id, dispatch)}
          editorOptions={Object.assign(clonedEditorOptions, extraOptions)}
        />
      );
    default:
      return null;
  }
}

function getVariantClassName(variant) {
  switch (variant) {
    case 'a':
      return 'a';
    case 'b':
      return 'b';
    case 'c':
      return 'c';
    case 'quoteD':
      return 'd';
    case 'fullBackground':
      return 'background';
    default:
      return null;
  }
}

function extractContent(s) {
  const span = document.createElement('span');
  span.innerHTML = s;
  return span.textContent || span.innerText;
}

function getConditionalClassToRemoveAfterBefore(variant, quoteText, nameText) {
  const classes = {
    classForQuote: '',
    classForName: ''
  };
  if (quoteText === '' && (variant === 'quoteD' || variant === 'c' || variant === 'a')) {
    classes.classForQuote = 'block-quote-delete-before-after';
  }
  if (nameText === '' && (variant === 'c' || variant === 'a')) {
    classes.classForName = 'block-quote-delete-before';
  }
  return classes;
}

function renderAvatar(varient, avatarThumb, styles) {
  if (varient === 'fullBackground') {
    return (
      <div className="block-quote__avatar" style={{ backgroundImage: `url(${avatarThumb})` }} />
    );
  }
  return (
    <div className="block-quote__image" style={styles.quoteDImage}>
      <div className="block-quote__avatar-wrap">
        <div className="block-quote__avatar" style={{ backgroundImage: `url(${avatarThumb})` }} />
      </div>
    </div>
  );
}

function renderQuote(variant, lesson, editable, dispatch) {
  if (variant === 'fullBackground') {
    return (
      <div className="block-quote__wrap">
        <div className="block-quote__text brand--linkColor brand--body brand--linkColor positionRelative">
          <div className="fr-view">{renderParagraph(lesson, editable, dispatch)}</div>
        </div>
        <div className="block-quote__caption brand--linkColor brand--head brand--linkColor">
          <div className="fr-view">{renderName(lesson, editable, dispatch)}</div>
        </div>
      </div>
    );
  }
  return (
    <div className="block-quote__wrap">
      <div className="block-quote__text brand--linkColor brand--body brand--linkColor">
        <div className="fr-view">{renderParagraph(lesson, editable, dispatch)}</div>
      </div>
      <div className="block-quote__caption brand--linkColor brand--head brand--linkColor">
        <div className="fr-view">{renderName(lesson, editable, dispatch)}</div>
      </div>
    </div>
  );
}

export default (props) => {
  const lesson = props.lesson;
  const variant = lesson.variant;
  const variantClassName = getVariantClassName(variant);
  const avatarThumb = lesson.items[0].avatar.media.image.thumbnail;
  const quoteText = extractContent(lesson.items[0].paragraph).trim();
  const nameText = extractContent(lesson.items[0].name).trim();
  const styles = {
    quoteDFigure: {},
    quoteDImage: {},
    quoteBackground: {}
  };

  let backgroundClassName = '';
  if (variant === 'quoteD') {
    styles.quoteDFigure = {
      display: 'flex',
      paddingRight: '20px',
      paddingLeft: '20px',
      maxWidth: '820px',
      margin: '0 auto'
    };
    styles.quoteDImage = { paddingRight: '20px' };
  }
  if (variant === 'fullBackground') {
    backgroundClassName = `block-quote__${variantClassName}`;
    styles.quoteBackground = {
      backgroundImage: `url(${lesson.items[0].background.media.image.src})`
    };
    styles.quoteDFigure = {
      paddingLeft: '50px',
      paddingRight: '50px',
      maxWidth: '820px',
      margin: '0 auto'
    };
  }

  const classToRemove = getConditionalClassToRemoveAfterBefore(variant, quoteText, nameText);

  const { editable, dispatch } = props;
  return (
    <div>
      <div
        className={`block-quote block-quote--${variantClassName} ${classToRemove.classForQuote} ${classToRemove.classForName}`}
      >
        <div className={backgroundClassName} style={styles.quoteBackground}>
          <div className="">
            <div className="">
              <figure className="block-quote__figure" style={styles.quoteDFigure}>
                {renderAvatar(variant, avatarThumb, styles)}
                {renderQuote(variant, lesson, editable, dispatch)}
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
